
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"24","height":"24","viewBox":"0 0 24 24","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M15 2a1 1 0 100 2h3.586l-5.293 5.293a1 1 0 001.414 1.414L20 5.414V9a1 1 0 102 0V3a1 1 0 00-1-1h-6zM4 15a1 1 0 10-2 0v6a1 1 0 001 1h6a1 1 0 100-2H5.414l5.293-5.293a1 1 0 00-1.414-1.414L4 18.586V15z","fill":"#04080E"}})])
          )
        }
      }
    